module.exports = __webpack_public_path__ + "img/Lost.89174ba7.jpg";